import { render, staticRenderFns } from "./Emptybody.vue?vue&type=template&id=fc384794&scoped=true"
import script from "./Emptybody.vue?vue&type=script&lang=js"
export * from "./Emptybody.vue?vue&type=script&lang=js"
import style0 from "./Emptybody.vue?vue&type=style&index=0&id=fc384794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc384794",
  null
  
)

export default component.exports